import Image from 'next/image';
import { Wrapper, LeverageBackground, Title, APY, Label } from './LeverageLiquidity.styles';
import Link from '@components/common/Link';
import CountUp from 'react-countup';
import { useFinalOusdApy } from '@components/store/getters';

const formatNumberWithCommas = (value: Number) => {
  return value.toLocaleString();
};

export default function Leverage() {
  const ltApy = useFinalOusdApy();
  return (
    <LeverageBackground>
      <Wrapper>
        <div>
          <Title type="h1">Taking Leverage</Title>
          <p>
            Buy ARCH Tokens on Uniswap, then Open a Position by depositing collateral and paying with ARCH tokens for
            access to leverage.
          </p>
          <p>Get your Tradeable Position wrapped as an NFT, and enjoy high yields at reduced risks.</p>
          {!!ltApy && (
            <APY type="h1">
              <CountUp useEasing duration={3} end={ltApy} formattingFn={formatNumberWithCommas} decimals={2} />%
            </APY>
          )}
          <Label>Current Estimated Net APY</Label>
          <p>
            <Link href="/open-position" variant="outline">
              Open a Position
            </Link>
          </p>
          <p>
            <Link target="_blank" href="https://docs.archimedesfi.com/" variant="thick">
              User Docs
            </Link>
          </p>
        </div>
        <Image src="/home/leverage.svg" alt="" width={478} height={321} />
      </Wrapper>
    </LeverageBackground>
  );
}
